<panel>
	<h1>{{ 'clean-up-domains.header' | translate }}</h1>
	@if (domains) {
		<list-view scrollable>
			<row *listData="let domain from domains" (action)="selectedDomain = domain; selectedCompanyId = undefined; companyInfo = undefined">
				<column>{{ domain.name }}</column>
			</row>
		</list-view>
	}
	@else {
		<skeletons [defaultSkeletons]="3" />
	}
</panel>

@if (selectedDomain) {
	<panel>
		<h1>{{ selectedDomain.name }}</h1>
		<section>
			<text-group>
				<a href="https://{{ selectedDomain.name }}" target="_blank">https://{{ selectedDomain.name }}</a>
				<a href="https://www.whois.com/whois/{{ selectedDomain.name }}" target="_blank">{{ 'clean-up-domains.whois-lookup' | translate }}</a>
			</text-group>
			@if (selectedCompanyId) {
				<div>
					@if (companyInfo) {
						<strong> {{ companyInfo.name }} </strong>
						<button [loader]="false" small (click)="selectedCompanyId = undefined; companyInfo = undefined"><icon type="xmark" /></button>
					}
					@else { <skeleton /> }
				</div>
			}
			@else {
				<company-search (onSelected)="selectCompany($event)" />
			}
		</section>
		<section>
			<button reject #removeDomainButton (click)="removeDomain()"><icon type="trash" />{{ 'company.domains.remove' | translate }}</button>
			<button #moveButton confirm [active]="!!selectedCompanyId && !!companyInfo" (click)="moveToSelectedCompany()">{{ 'clean-up-domains.move-to-selected-company' | translate }}</button>
		</section>
	</panel>
}
